import React, { useContext } from 'react';
import classnames from 'classnames';
import Pane from "../Pane.js";
import Theme from "../Theme.js";
import S from '../Tree.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NodeRenderer(props) {
  const {
    selected,
    selectedClassName = S.selectedNode,
    wrapperProps
  } = props;
  const {
    renderer: Renderer,
    iconRenderer: IconRenderer,
    nodeProps,
    className,
    layout = 'flex:rowM',
    onEvent,
    preCmp,
    postCmp
  } = wrapperProps;
  const theme = useContext(Theme.Context);
  const cn = theme.subclasses('Tree', 'treeNode', className, classnames(S.node, S.win), selected ? selectedClassName : '');
  return /*#__PURE__*/_jsxs(Pane, {
    layout: layout,
    className: cn,
    children: [/*#__PURE__*/_jsx(IconRenderer, {
      ...props,
      ...nodeProps,
      onEvent: onEvent
    }), /*#__PURE__*/_jsx(Renderer, {
      preCmp: preCmp,
      postCmp: postCmp,
      ...props,
      ...nodeProps,
      onEvent: onEvent
    })]
  });
}
export default function NodeRendererWrapper(wrapperProps) {
  return function render(props) {
    // I seemingly have to do this or I get hooks errors :/
    return /*#__PURE__*/_jsx(NodeRenderer, {
      ...props,
      wrapperProps: wrapperProps
    });
  };
}